import React, { useContext } from "react";
import Avatar from "../../../elements/Avatar";
import Button from "../../../elements/Button";
import Dialog from "../../../elements/Dialog";
import { patchData } from "../../../utils/api";
import { UserContext } from "../../../UserContext";
import { useMembers, useMembersToast } from "../MembersContext";

const ResendInvite = ({ member }) => {
  const { currentUser } = useContext(UserContext);
  const { dispatch } = useMembers();
  const { dispatchToast } = useMembersToast();

  async function resendInvite() {
    try {
      const response = await patchData(`/${currentUser.organizationId}/resend_invite`, { id: member.id });
      dispatch({ type: "resend_invite", payload: { member: response.user } });
      dispatchToast({ type: "success_toast", payload: response.notice || "Invite successfully resent" });
    } catch (error) {
      console.log(error);
      dispatchToast({ type: "error_toast" });
    }
  }

  return (
    <Dialog
      trigger={
        <Button variant="secondary" utilityClasses="br--pill ph--12">
          Resend Invite
        </Button>
      }
      title="Resend Invitation"
      description="Resend your invitation to join your team on MOSAIC."
      confirm={
        <Button
          onClick={resendInvite}
          utilityClasses="ph--8 br--pill lh--tight flex--item-grow1"
          data-cy="dialog__resend-invite-confirmation"
        >
          Confirm
        </Button>
      }
      cancel={
        <Button variant="secondary" utilityClasses="ph--24 br--pill lh--tight">
          Cancel
        </Button>
      }
    >
      <div className="display--flex flex--items-center gap--16 pa--24 br--8 bg--dialog-input">
        <Avatar initials={member.initials} size="lg" />
        <div>
          <h3 className="fs--18 fw--500">{member.name}</h3>
          <span className="fs--12">{member.email}</span>
        </div>
      </div>
    </Dialog>
  );
};

export default ResendInvite;
